import { getCachedMediaUrl } from '../../../../lib/utils/utils';

function ProductInsightsListItem({ product }) {
    return (
        <div className="flex items-center gap-2 border-t border-[#EAEAEA]">
            <div className="flex items-center gap-2 w-[56%] p-[6px_10px_6px_16px]">
                {
                    product?.productImgUrls?.length > 0 ?
                    <div className="size-11 rounded-[5.5px] overflow-hidden">
                        <img className='size-full object-cover' src={getCachedMediaUrl(product.productImgUrls[0])} alt={product.productName} />
                    </div> : 
                    <div className="size-11 rounded-[5.5px] bg-[#EAEAEA]"></div>
                }

                <h2 className='w-[calc(100%-44px)] text-[#121212] font-medium text-[14px] leading-6 line-clamp-1'>{product.productName}</h2>
            </div>

            <div className="flex flex-col w-[22%] p-[6px_10px_6px_16px]">
                <p className="font-normal text-[14px] leading-6 text-[#121212]">{product.orderCount}</p>
            </div>

            <div className="flex flex-col w-[22%] p-[6px_10px_6px_16px]">
                <p className="text-[14px] leading-6 text-[#121212]">{product.productStock ? product.productStock : '-'}</p>
            </div>
        </div>
    );
}

export default ProductInsightsListItem;
